import SpecialSalaryPatternInputSettingForm from './SpecialSalaryPatternInputSettingForm';

export default SpecialSalaryPatternInputSettingForm;
